import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

// Public key for connect endpoints
let publicKey = process.env.REACT_APP_PUBLIC_KEY || '';

export const setPublicKey = (key) => {
  publicKey = key;
};

export const createConnectSession = async (userId) => {
  const res = await api.post('/api/connect/session', { userId }, {
    headers: { 'x-public-key': publicKey },
  });
  return res.data;
};

export const completeAccountLink = async (sessionId, userId, institution, authCode) => {
  const res = await api.post('/api/connect/complete', { sessionId, userId, institution, authCode }, {
    headers: { 'x-public-key': publicKey },
  });
  return res.data;
};

// Auth
export const registerUser = async (email, password, fullName) => {
  const res = await api.post('/api/auth/register', { email, password, fullName });
  return res.data;
};

export const loginUser = async (email, password) => {
  const res = await api.post('/api/auth/login', { email, password });
  return res.data;
};

// App management
export const createApiApp = async (token, name, environment = 'test') => {
  const res = await api.post('/api/apps', { name, environment }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const listApiApps = async (token) => {
  const res = await api.get('/api/apps', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export default api;
